<template>
  <v-chip 
    @click.stop.prevent="handleClick" 
    size="x-small" 
    class="favoriteChip">
    <v-icon class="heart" :icon="isFavorited ? 'mdi-heart' : 'mdi-heart-outline'" :style="isFavorited ? 'color: ' + heartColour : ''" />
  </v-chip>
</template>

<script>
export default {
  name: 'FavoriteChip',
  emits: ['favorite-clicked'],
  props: {
    isFavorited: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    },
    heartColour: {
      type: String,
      default: 'red'
    }
  },
  methods: {
    handleClick(event) {
      event.stopPropagation();
      event.preventDefault();
      this.$emit('favorite-clicked', !this.isFavorited);
    }
  }
};
</script>

<style scoped>
.favoriteChip {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: v-bind('transparent ? "transparent" : "#FFFFFF"') !important;
  border-radius: 50%;
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  min-width: 24px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.favoriteChip .v-icon.heart {
  font-size: 12px !important;
  width: auto !important;
  height: auto !important;
}
</style>